<script setup lang="ts">
import SettlementManagement from "@/views/playground/planner/business-management/settlement-management/SettlementManagement.vue";
</script>

<template>
  <settlement-management></settlement-management>
</template>

<style scoped></style>
